import { v4 } from 'uuid';
import {
  AsyncLogicParams,
  REGISTRATION_URL,
  HOST_URL,
  TEST_URL
} from './index';

const fundingLogic: Array<AsyncLogicParams> = [
  {
    name: 'getBankName',
    axiosConfig: (payload, publicRuntimeConfig, getState) => ({
      method: 'get',
      url: `${HOST_URL(publicRuntimeConfig)}/bank/${payload.routingNumber}`,
      headers: {
        'client-ip-address': getState().user.ipAddress
      }
    }),
    shouldSetGlobalAsyncProperties: false
  },
  {
    name: 'getBraintreeToken',
    axiosConfig: (payload, publicRuntimeConfig, getState) => ({
      method: 'get',
      url: `${REGISTRATION_URL(
        publicRuntimeConfig
      )}/query?actionType=get_braintree_client_token`,
      headers: {
        'x-test-tracer': v4(),
        Authorization: `Bearer ${getState().app.registrationToken}`,
        'client-ip-address': getState().user.ipAddress
      }
    }),
    registrationStep: 'set_funding_account'
  },
  {
    name: 'getFundingAccounts',
    axiosConfig: (payload, publicRuntimeConfig, getState) => ({
      method: 'get',
      url: `${REGISTRATION_URL(
        publicRuntimeConfig
      )}/query?actionType=get_funding_accounts`,
      headers: {
        'x-test-tracer': v4(),
        Authorization: `Bearer ${getState().app.registrationToken}`,
        'client-ip-address': getState().user.ipAddress
      }
    }),
    registrationStep: 'set_funding_account'
  },
  {
    name: 'getMicrodeposits',
    axiosConfig: (payload, publicRuntimeConfig, getState) => ({
      method: 'post',
      url: `${TEST_URL(publicRuntimeConfig)}/micro-deposit-discovery`,
      data: {
        funding_account_id: payload.fundingAccountId,
        funding_type: payload.fundingAccountType
      },
      headers: {
        Authorization: `Bearer ${getState().app.registrationToken}`,
        'client-ip-address': getState().user.ipAddress
      }
    }),
    shouldSetGlobalAsyncProperties: false
  },
  {
    name: 'getPlaidToken',
    axiosConfig: (payload, publicRuntimeConfig, getState) => ({
      method: 'post',
      url: `${REGISTRATION_URL(
        publicRuntimeConfig
      )}/query-with-params?actionType=get_plaid_link_token`,
      data: {
        params: {
          platform: payload.platform
        }
      },
      headers: {
        Authorization: `Bearer ${getState().app.registrationToken}`,
        'client-ip-address': getState().user.ipAddress
      }
    }),
    registrationStep: 'set_funding_account'
  },
  {
    name: 'queryGetInitialFunding',
    axiosConfig: (payload, publicRuntimeConfig, getState) => ({
      method: 'get',
      url: `${REGISTRATION_URL(
        publicRuntimeConfig
      )}/query?actionType=get_initial_funding`,
      headers: {
        'x-test-tracer': v4(),
        Authorization: `Bearer ${getState().app.registrationToken}`,
        'client-ip-address': getState().user.ipAddress
      }
    }),
    registrationStep: 'set_funding_account'
  },
  {
    name: 'verifyDebitNow',
    axiosConfig: (payload, publicRuntimeConfig, getState) => ({
      method: 'post',
      url: `${REGISTRATION_URL(
        publicRuntimeConfig
      )}/query-with-params?actionType=verify_instant_funding_account`,
      data: {
        params: {
          instant_funding_account_id: payload.instantFundingAccountId,
          amount_1: payload.amount1,
          amount_2: payload.amount2
        }
      },
      headers: {
        'x-test-tracer': v4(),
        Authorization: `Bearer ${getState().app.registrationToken}`,
        'client-ip-address': getState().user.ipAddress
      }
    }),
    registrationStep: 'verify_funding'
  }
];

export default fundingLogic;
